import toFarsiNumbers from './tools/toFarsiNumbers';
import iconTrash from './svg/icon-trash.svg';
import iconSetting from './svg/icon-setting.svg';

export default function Header({
  setModalMode,
  numTasks,
  onDeleteToggle,
  deleteMode,
  today,
  selectedDay,
}) {
  function dateFormater(date) {
    const day = date.toLocaleDateString('fa-IR', {
      day: 'numeric',
      month: 'long',
    });
    const weekday = date.toLocaleDateString('fa-IR', {
      weekday: 'long',
    });
    return `${weekday}، ${day}`;
  }

  return (
    <div className="bg-primary text-secondary px-6 pt-8 pb-8">
      {/* top container */}
      <div className="flex justify-between items-center  pb-10 ">
        {/* trash */}
        <div
          className={`transition-all duration-150 ${
            deleteMode ? 'animate-wiggle w-12 h-12' : 'w-7.5 h-7.5'
          }`}
          onClick={onDeleteToggle}
        >
          <img src={iconTrash} alt="trash" />
        </div>

        {/* date */}
        <div className="text-3xl font-thin">
          {today.toLocaleDateString('fa-IR', {
            day: 'numeric',
            month: 'long',
          })}
        </div>

        {/* setting */}
        <div className="w-8.5 h-8.5" onClick={() => setModalMode('setting')}>
          <img src={iconSetting} alt="settings" />
        </div>
      </div>

      {/* bottom container */}
      <div className="flex justify-between items-center px-2 pb-5.5">
        {/* right container */}
        <div>
          <h3 className="text-4xl text-white font-extralight">
            {selectedDay.getTime() === today.getTime()
              ? 'امروز'
              : dateFormater(selectedDay)}
          </h3>

          <h5 className="text-xs font-t px-2  font-extralight ">
            {numTasks !== 0
              ? `${toFarsiNumbers(numTasks)} فعالیت`
              : `فعالیتی برای ${
                  selectedDay.getTime() === today.getTime()
                    ? 'امروز'
                    : 'روز انتخابی'
                } وجود ندارد`}
          </h5>
        </div>
        {/* left container */}
        <div>
          <button
            className="bg-white border-2 text-primary px-3.5 py-2.5 text-md rounded-lg hover:bg-primary hover:text-white hover:font-extrabold duration-150"
            onClick={() => setModalMode('create')}
          >
            اضافه کردن
          </button>
        </div>
      </div>
    </div>
  );
}
